// extracted by mini-css-extract-plugin
export default {"description":"_23MSv"};